
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.656 3c.523 0 1.041.189 1.469.531l.063.031.031.031 4.094 4.219-.031.031c.886.826.873 2.221.031 3.063l-2 2c.307.705 1.146 2.501 2.781 4.063a16.139 16.139 0 004.094 2.813l2-2c.83-.83 2.295-.83 3.125 0l.031.063 4.063 4.063c.83.83.83 2.264 0 3.094l-3.156 3.156a3.595 3.595 0 01-3.469.688h-.031c-2.347-.918-7.094-3.001-11.344-7.25-4.233-4.233-6.403-8.916-7.25-11.344-.002-.006.002-.025 0-.031a3.134 3.134 0 01.844-3.375l-.031-.031 3.156-3.25.063-.031a2.362 2.362 0 011.469-.531zm0 2a.363.363 0 00-.219.094L5.343 8.25c-.355.304-.465.906-.313 1.313.758 2.178 2.825 6.669 6.781 10.625 3.924 3.924 8.326 5.86 10.594 6.75.584.195 1.069.115 1.531-.281l3.063-3.063c.17-.17.17-.111 0-.281l-4.094-4.094c-.17-.17-.142-.17-.313 0l-2.969 2.969-.625-.281s-2.739-1.16-5.063-3.281l-.219-.188c-2.412-2.303-3.563-5.375-3.563-5.375l-.219-.625.469-.438 2.5-2.5c.123-.123.055-.225.063-.219l-.094-.094-4-4.094a.361.361 0 00-.219-.094z"}})])
          )
        }
      }
    